import {ActionTree} from 'vuex'
import {IAgencyManagementState} from './am-state.store'
import {IRootState} from '../root-state.store'
import * as _ from './am-types.store'
import {CrudStatus} from '../../common/enums'

export const actions: ActionTree<IAgencyManagementState, IRootState> = {
  [_.AM_CHAR_PBS]: async ({ commit, state }, param) => {
    return state.service.getCharacterProblems(param)
      .then(res => {
        commit(_.AM_CHAR_PBS, res)
        return res
      })
      .catch(err => err)
  },
  [_.AM_CHAR_PB]: async ({ commit, state }, id) => {
    return state.service.getCharacterProblem(id)
      .then(res => {
        commit(_.AM_CHAR_PB, res)
        return res
      })
      .catch(err => err)
  },
  [_.AM_RECORD_CHAR_PB]: async ({commit, getters, state}) => {
    return state.service.recordCharPb(getters.characterProblemToEdit)
      .then(response => {
        commit(_.AM_CHAR_PB_TO_EDIT, {})
        return Promise.resolve(response)
      })
      .catch(err => Promise.reject(err))
  },
  [_.AM_RECORD_ATTACHMENT_TYPE]: async ({commit, getters, state}) => {
    return state.service.recordAttachmentType(getters.attachmentTypeToEdit)
      .then(response => {
        commit(_.AM_ATTACHMENT_TYPE_TO_EDIT, {})
        return Promise.resolve(response)
      })
      .catch(err => Promise.reject(err))
  },
  [_.AM_RESET_CHAR_PB_TO_EDIT]: async ({commit, getters}) => {
    commit(_.AM_ACTION, CrudStatus.NoAction)
    commit(_.AM_CHAR_PB_TO_EDIT, {})
  },
  [_.AM_RESET_ATTACHMENT_TYPE_TO_EDIT]: async ({commit, getters}) => {
    commit(_.AM_ACTION, CrudStatus.NoAction)
    commit(_.AM_ATTACHMENT_TYPE_TO_EDIT, {})
  },
  [_.AM_CHAR_PB_TO_EDIT]: async ({commit, getters}) => {
    let currentCP = Object.assign({}, {...getters.characterProblem})
    commit(_.AM_CHAR_PB_TO_EDIT, {
      name: currentCP.name,
      level: currentCP.level,
      picto: currentCP.picto,
      fk_cp1_parent: currentCP.agency_character_problem.fk_cp1_parent,
      code: currentCP.code,
      enabled: currentCP.agency_character_problem.enabled
    })
    commit(_.AM_ACTION, CrudStatus.Update)
  },
  [_.AM_ATTACHMENT_TYPE_TO_EDIT]: async ({commit, getters}) => {
    let currentAT = Object.assign({}, {...getters.attachmentType})
    commit(_.AM_ATTACHMENT_TYPE_TO_EDIT, {
      name: currentAT.name,
      level: currentAT.level,
      picto: currentAT.icon,
      fk_doc_type_parent: currentAT.fk_doc_type_parent || null,
      enabled: currentAT.enabled
    })
    commit(_.AM_ACTION, CrudStatus.Update)
  },
  [_.AM_ATTRIBUTE_TO_EDIT]: async ({commit, getters}, attribute) => {
    commit(_.AM_ATTRIBUTE, Object.assign({}, {...attribute}))
    commit(_.AM_ATTRIBUTE_TO_EDIT, {
      name: attribute.name,
      unit: attribute.unit,
      used_by_maintenance:attribute.used_by_maintenance,
      used_by_alert:attribute.used_by_alert,
      alert_pre_delay:attribute.alert_pre_delay,
      fk_attribute_type: attribute.fk_attribute_type
    })
    commit(_.AM_ACTION, CrudStatus.Update)
  },
  [_.AM_CHAR_PB_UPDATE]: async ({commit, state, getters}) => {
    let currentCP = Object.assign({}, {...getters.characterProblem})
    let newCP = Object.assign({}, {...getters.characterProblemToEdit})
    let changes: any = {}
    if (currentCP.name !== newCP.name) changes.name = newCP.name
    if (currentCP.level !== newCP.level) changes.level = newCP.level
    if (currentCP.picto !== newCP.picto) changes.picto = newCP.picto
    if (currentCP.code !== newCP.code) changes.code = newCP.code
    if (currentCP.enabled !== newCP.enabled) changes.enabled = newCP.enabled
    if (Object.keys(changes).length === 0) {
      return Promise.resolve(currentCP).then(() => {
        commit(_.AM_ACTION, CrudStatus.NoAction)
        commit(_.AM_CHAR_PB_TO_EDIT, {})
      })
    } else {
      return state.service.updateCharPb(currentCP.id, changes)
        .then(response => {
          commit(_.AM_CHAR_PB, {
            ...currentCP,
            ...response
          })
          commit(_.AM_ACTION, CrudStatus.NoAction)
          commit(_.AM_CHAR_PB_TO_EDIT, {})
        })
    }
  },
  [_.AM_ATTACHMENT_TYPE_UPDATE]: async ({commit, state, getters}) => {
    let currentAT = Object.assign({}, {...getters.attachmentType})
    let newAT = Object.assign({}, {...getters.attachmentTypeToEdit})
    let changes: any = {}
    if (currentAT.name !== newAT.name) changes.name = newAT.name
    if (currentAT.level !== newAT.level) changes.level = newAT.level
    if (currentAT.picto !== newAT.picto) changes.picto = newAT.picto
    if (currentAT.enabled !== newAT.enabled) changes.enabled = newAT.enabled
    if (Object.keys(changes).length === 0) {
      return Promise.resolve(currentAT).then(() => {
        commit(_.AM_ACTION, CrudStatus.NoAction)
        commit(_.AM_ATTACHMENT_TYPE_TO_EDIT, {})
      })
    } else {
      return state.service.updateAttachmentType(currentAT.id, changes)
        .then(response => {
          commit(_.AM_ATTACHMENT_TYPE, {
            ...currentAT,
            ...response
          })
          commit(_.AM_ACTION, CrudStatus.NoAction)
          commit(_.AM_ATTACHMENT_TYPE_TO_EDIT, {})
        })
    }
  },
  [_.AM_GET_ATTRIBUTE_TYPES]: async ({commit, state, getters}) => {
    return state.service.getAttributeTypes()
      .then(response => {
        commit(_.AM_SET_ATTRIBUTE_TYPES, response)
        return Promise.resolve(response)
      })
      .catch(err => Promise.reject(err))
  },
  [_.AM_RECORD_ATTRIBUTE]: async ({commit, getters, state}) => {
    let currentCP = Object.assign({}, {...getters.characterProblem})
    return state.service.recordAttribute(currentCP.id, getters.attributeToEdit)
      .then(response => {
        commit(_.AM_CHAR_PB, {
          ...currentCP,
          attributes: [
            ...currentCP.attributes,
            response
          ]
        })
        commit(_.AM_ACTION, CrudStatus.NoAction)
        commit(_.AM_ATTRIBUTE_TO_EDIT, {})
        return Promise.resolve(response)
      })
      .catch(err => Promise.reject(err))
  },
  [_.AM_UPDATE_ATTRIBUTE]: async ({commit, getters, state}) => {
    let currentCP = Object.assign({}, {...getters.characterProblem})
    let currentAttribute = Object.assign({}, {...getters.attribute})
    let attributeToSend = Object.assign({}, {...getters.attributeToEdit})
    delete attributeToSend.fk_attribute_type
    return state.service.updateAttribute(currentCP.id, currentAttribute.id, attributeToSend)
      .then(response => {
        let attributes = currentCP.attributes
        attributes[attributes.findIndex(x => x.id === currentAttribute.id)] = response
        commit(_.AM_CHAR_PB, {
          ...currentCP,
          attributes
        })
        commit(_.AM_ACTION, CrudStatus.NoAction)
        commit(_.AM_ATTRIBUTE_TO_EDIT, {})
        return Promise.resolve(response)
      })
      .catch(err => Promise.reject(err))
  },
  [_.AM_RECORD_AT_ATTRIBUTE]: async ({commit, getters, state}) => {
    let currentAT = Object.assign({}, {...getters.attachmentType})
    return state.service.recordATAttribute(currentAT.id, getters.attributeToEdit)
      .then(response => {
        commit(_.AM_ATTACHMENT_TYPE, {
          ...currentAT,
          attributes: [
            ...currentAT.attributes,
            response
          ]
        })
        commit(_.AM_ACTION, CrudStatus.NoAction)
        commit(_.AM_ATTRIBUTE_TO_EDIT, {})
        return Promise.resolve(response)
      })
      .catch(err => Promise.reject(err))
  },
  [_.AM_UPDATE_AT_ATTRIBUTE]: async ({commit, getters, state}) => {
    let currentAT = Object.assign({}, {...getters.attachmentType})
    let currentAttribute = Object.assign({}, {...getters.attribute})
    let attributeToSend = Object.assign({}, {...getters.attributeToEdit})
    delete attributeToSend.fk_attribute_type
    return state.service.updateATAttribute(currentAT.id, currentAttribute.id, attributeToSend)
      .then(response => {
        let attributes = currentAT.attributes
        attributes[attributes.findIndex(x => x.id === currentAttribute.id)] = response
        commit(_.AM_ATTACHMENT_TYPE, {
          ...currentAT,
          attributes
        })
        commit(_.AM_ACTION, CrudStatus.NoAction)
        commit(_.AM_ATTRIBUTE_TO_EDIT, {})
        return Promise.resolve(response)
      })
      .catch(err => Promise.reject(err))
  },
  [_.AM_RESET_ATTRIBUTE_TO_EDIT]: async ({commit, getters}) => {
    commit(_.AM_ACTION, CrudStatus.NoAction)
    commit(_.AM_ATTRIBUTE_TO_EDIT, {})
  },
  [_.AM_ATTACHMENT_TYPES]: async ({ commit, state }, param) => {
    return state.service.getAttachmentTypes(param)
      .then(response => {
        commit(_.AM_ATTACHMENT_TYPES, response)
        return Promise.resolve(response)
      })
      .catch(err => Promise.reject(err))
  },
  [_.AM_ATTACHMENT_TYPE]: async ({ commit, state }, id) => {
    return state.service.getAttachmentType(id)
      .then(res => {
        commit(_.AM_ATTACHMENT_TYPE, res)
        return res
      })
      .catch(err => err)
  },
  [_.AM_CHAR_PB_DELETE]: async ({commit, getters, state}, id) => {
    return state.service.deleteCharPb(id)
  }
}



// WEBPACK FOOTER //
// ./src/store/agency-management/am-action.store.ts